import { ReactElement } from 'react';
import styled from 'styled-components';
import breakpoints from '@designSystem/breakpoints';
import colors from '@designSystem/colors';
import { baseTyping } from '@designSystem/typings';

const TileContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background: ${colors.lighterGrey};
  border-radius: 10px;

  width: 80px;
  min-width: 80px;
  height: 80px;

  ${baseTyping}
  font-size: 12px;
  line-height: 16px;
  color: ${colors.darkGrey};

  cursor: pointer;

  & svg {
    padding-bottom: 2px;
    width: 14px;
    height: 14px;
  }

  & span {
    padding-top: 2px;
  }

  &[aria-selected='true'] {
    border: 2px solid ${colors.green};
    path {
      stroke: ${colors.green};
    }
  }

  @media (max-width: ${breakpoints.large}) {
    width: 64px;
    min-width: 64px;
    height: 64px;
  }
`;

export type IconTileI = {
  icon: ReactElement;
  label: string;
  onClick?: () => void;
  isActive?: boolean;
};

const IconTile = ({
  icon,
  label,
  onClick,
  isActive,
}: IconTileI): ReactElement => {
  return (
    <TileContainer aria-selected={isActive} onClick={onClick}>
      {icon}
      <span>{label}</span>
    </TileContainer>
  );
};

export default IconTile;
